import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InventoriesComponent } from '@src/app/features/inventories/inventories/inventories.component';
import { AddInventoryComponent } from '@src/app/features/inventories/add-inventory/add-inventory.component';
import { ViewInventoryComponent } from '@src/app/features/inventories/view-inventory/view-inventory.component';
import { EditInventoryComponent } from '@src/app/features/inventories/edit-inventory/edit-inventory.component';

const routes: Routes = [
  { path: '', component: InventoriesComponent },
  { path: 'add', component: AddInventoryComponent },
  { path: ':inventoryId/edit', component: EditInventoryComponent },
  { path: ':inventoryId', component: ViewInventoryComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InventoriesRoutingModule { }
